<template>
    <div class="sidebar-content loadingbg">
        <div class="midblock">

            <div class="padding20">
                <div class="font14 bold width100 margintop20 marginbottom30">
                    <span
                        class="darkblue"
                        v-html="' Cruise'"
                    ></span
                    ><br />
                    <small class="darkblue font11"
                        >met schip</small
                    >
                </div>
                <div
                    class="width100 marginbottom10 margintop10 font14"
                    style="color: #7f8386;"
                    v-bind:class="{
            show: !isMobile,
            hide: isMobile}"
                >
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />
                    <b>Aan het laden</b> <br />


                </div>

            </div>

            <div class="clearfix"></div>
        </div>

        <div  class="sidebar-ups">

        <div class="content">
            <h3 class="title">Daarom CruiseReizen.nl</h3>
            <ul>
                <li><b>Geen</b> verborgen kosten</li>
                <li><b>Laagsteprijsgarantie</b></li>
                <li><b>7 dagen</b> p/w geopend</li>
                <li>Klantbeoordeling <b>9.8/10</b></li>
                <li><b>45.506</b> vind-ik-leuks</li>
                <li><b>ANVR</b>, <b>SGR</b> en <b>CLIA</b> lid</li>
                <li>Het ruimste aanbod</li>
            </ul>
        </div>
        </div>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMinus, faPlane, faPlus } from '@fortawesome/free-solid-svg-icons'

library.add(faPlane)
library.add(faPlus)
library.add(faMinus)

export default {
    name: 'SideBarLoading',
  data: function() {
    return {
      isMobile: window.innerWidth < 741,
    }
  },
}
</script>

<style scoped lang="scss">
.sidebar-content {
  position: -webkit-sticky;
  position: sticky;
  top: 30px;

  .sidebarHeaderImage {
    border-radius: 5px 5px 0 0;
  }

  .sideBarRederijLogo {
    background-color: #ffffff;
    padding: 0 0 0 5px;
    position: absolute;
    border-radius: 3px;
    top: 5px;
    left: 5px;
  }

  .costacruiseslogo-small {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1582px -204px;
    width: 42px;
    height: 32px;
  }

  .hollandamericalinelogo-small {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1170px -162px;
    width: 92px;
    height: 36px;
  }

  .msccruiseslogo-small {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -1274px -166px;
    width: 68px;
    height: 30px;
  }

  .sidebar-ups {
    margin-top: 25px !important;

    .content {
      padding: 20px 15px;
      color: #fff;
      background-color: #2178b3;
    }

    h3 {
      padding: 0;
      margin: 0;
    }

    ul {
      padding: 10px 0 0 20px;
      margin: 0;
    }
  }

  .green{
    color :#2f7000;
  }
}
</style>
<style lang="scss">

.loadingbg .midblock{
  position: relative;
  pointer-events: none;

  &:after {
    position:absolute;
    top:0;
    bottom:0;
    right:0;
    left:0;
    content: '';
    background: #fff;
    z-index:1000;
  }

  span, .fakebox, button, b {
    position: relative;

    &:before {
      position:absolute;
      top:0;
      bottom:0;
      right:0;
      left:0;
      content: '';
      background-image: linear-gradient(75deg, #fff 40%, #f8f8f8 45%, #f8f8f8 50%, #f8f8f8 60%, #f8f8f8 65%, #fff 80%);
      z-index:2000;
      background-size: 300% 100%;
      animation: lazyPanda 2s infinite;
    }
  }
}
.loadingbg.sidebar-content .midblock {
  pointer-events: none;
  border-color: #afc9da;
  &:after {
    position:absolute;
    top:0;
    bottom:0;
    right:0;
    left:0;
    content: '';
    background-image: linear-gradient(75deg, #fff 40%, #f8f8f8 45%, #f8f8f8 50%, #f8f8f8 60%, #f8f8f8 65%, #fff 90%);
    z-index:3000;
    background-size: 300% 100%;
    animation: lazyPanda 4s infinite;
  }
}
@keyframes lazyPanda {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 120% 0;
  }
}
</style>